export const exclude = {
  name: "exclude",
  type: "word",
  parseWordCondition: (word) => word.startsWith("-"),
  parseWordAction: (word) => word.slice(1),
  format: (text) => `-${text.trim().replace(" ", " -")}`,
  label: "Exclure les mots suivants",
};
